export default __webpack_public_path__ + "static/media/41k.2776de66.md";